export default class FileInfo {
	FileName: string = "";
	Poznamka: string = "";

	public constructor(init?: Partial<FileInfo>) {
		Object.assign(this, init);
	}
}